import React from "react";
import { func } from "prop-types";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import { USER_ROLES } from "UTILS/Constants";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class InitializeMfaModal extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };

  handleInitializeClick = () => {
    this.props.handleInitializeClick(this.props.userData);
  };

  handleCancelClick = () => {
    this.props.handleCancelClick();
  };

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          onClick={this.handleInitializeClick}
          className="buttons borderBtn customBtn resetButton whiteOnClick"
        >
          {getMessage("MFA_RESET_BUTTON")}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <Modal isOpen={this.props.show} className="resetMfaModal" backdrop="static" toggle={ this.props.handleCancelClick}>
        <ModalBody>{getMessage("MFA_RESET_RECONFIRM",
          {initializeMfaEmail: (this.props.initializeMfaEmail) })}</ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(InitializeMfaModal);
